import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import TProductDeutscheTelekomBrandLogo from "@/icons/TProduct/DeutscheTelekomBrandLogo";

import { Icon } from "../Icon";
import { A11yText } from "../A11yText";
import Link from "./Link";
import Divider from "./Divider";

import styles from "./BrandBar.scss";

export const BrandBar = forwardRef(
  (
    {
      logoHref,
      logoAlt,
      claim,
      claimAlt,
      children,
      minimized,
      expanded,
      ...props
    },
    ref
  ) => {
    // Using React.Children.toArray().length as it counts renderable elements vs slots
    const childrenCount = React.Children.toArray(children).length;
    const classes = classNames(styles.wrapper, {
      [styles["wrapper--minimized"]]: minimized,
      [styles["wrapper--expanded"]]: expanded,
    });

    const claimClasses = classNames(styles.claim, {
      // hide claim when there are children in viewports s
      [styles.hiddenS]: childrenCount > 0,
    });
    return (
      <div ref={ref} className={classes} {...props}>
        <div className={styles.inner}>
          <span className={styles.brandContent}>
            <a href={logoHref} className={styles.logoLink}>
              <A11yText>{logoAlt}</A11yText>
              <Icon
                wrapperProps={{ className: styles.logo }}
                icon={TProductDeutscheTelekomBrandLogo}
                color={Icon.Color.white}
              />
            </a>
            {claim && (
              <span className={claimClasses}>
                <A11yText>{claimAlt}</A11yText>
                {claim}
              </span>
            )}
          </span>
          {children && (
            <span className={styles.authoredContent}>{children}</span>
          )}
        </div>
      </div>
    );
  }
);

BrandBar.displayName = "BrandBar";

BrandBar.Link = Link;
BrandBar.Divider = Divider;

BrandBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  claim: PropTypes.node,
  minimized: PropTypes.bool,
  expanded: PropTypes.bool,
  logoHref: PropTypes.string.isRequired,
  logoAlt: PropTypes.string.isRequired,
  claimAlt: PropTypes.string,
};

BrandBar.defaultProps = {
  children: null,
  minimized: false,
  expanded: false,
  claim: null,
  claimAlt: null,
};

export default BrandBar;
